import { useState, useEffect } from 'react';
import useResponsivePageSize from './useresponsivepagesize';

const usePaginationAndSorting = (initialSortBy = '', initialPage = 1) => {
    const [page, setPage] = useState(initialPage);
    const [pageSize, setPageSize] = useState(null); // Start as `null` to wait for responsive size
    const [sortBy, setSortBy] = useState(initialSortBy);
    const responsivePageSize = useResponsivePageSize();

    useEffect(() => {
        if (responsivePageSize !== pageSize) {
            setPageSize(responsivePageSize);
        }
    }, [responsivePageSize, pageSize]);

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    const handleSortClick = (columnName) => {
        const sortOrderPrefix = sortBy.includes('desc_') ? 'asc_' : 'desc_';
        setSortBy(`${sortOrderPrefix}${columnName}`);
    };

    return { page, pageSize, sortBy, handlePageChange, handlePageSizeChange, handleSortClick };
};

export default usePaginationAndSorting;
